<template>
  <div>
    <yes-no-maybe-selector :downClassYes="downClassYes" :hideDontKnowOption="hideDontKnowOption" v-model="yesNoMaybeSelection"></yes-no-maybe-selector>

    <template v-if="yesNoMaybeSelection == 1 && askProductionDetails">
      <p>{{ $t('energyProduction.power') }}</p>
      <number-box :label="$t('energyProduction.kva')" :max="999" :min="0" :note="$t('energyProduction.kvaTooltips')" :step="0.1" data-cy="power-info-kva" v-model.number="kvaPower"></number-box>
      <p>{{ $t('common.andOr') }}</p>
      <number-box :label="$t('energyProduction.kwc')" :max="999" :min="0" :note="$t('energyProduction.kwcTooltips')" :step="0.01" v-model.number="kwcPower"></number-box>

      <div class="lib__feedback lib__feedback--info lib__feedback--simple">
        <div class="lib__feedback__icon">
          <i class="fas fa-lightbulb"></i>
        </div>
        <div class="lib__feedback__content">
          <p>{{ $t('energyProduction.info') }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch, Inject } from 'vue-property-decorator'
import { EnergySelection, AddressPoint, EnergyProductionInfoModel } from '@/models'
import { YesNoMaybeSelection } from '@ores/vue-library'

@Component({
  name: 'energy-production-info'
})
export default class EnergyProductionInfo extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: false }) public readonly value!: EnergyProductionInfoModel | null
  @Prop({ type: Boolean, required: false, default: true }) public readonly askProductionDetails!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly hideDontKnowOption!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly downClassYes!: boolean
  //#endregion

  //#region [Computed]
  public get yesNoMaybeSelection(): YesNoMaybeSelection | null {
    return this.value ? this.value.hasEnergyProduction : null
  }
  public set yesNoMaybeSelection(val: YesNoMaybeSelection | null) {
    this.change(val, null, null)
  }

  public get kvaPower(): number | null {
    return this.value ? this.value.kVAPower : null
  }
  public set kvaPower(val: number | null) {
    val = val + '' === '' ? null : val
    this.change(this.yesNoMaybeSelection, val, this.kwcPower)
  }

  public get kwcPower(): number | null {
    return this.value ? this.value.kwcPower : null
  }
  public set kwcPower(val: number | null) {
    val = val + '' === '' ? null : val
    this.change(this.yesNoMaybeSelection, this.kvaPower, val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(
    data: YesNoMaybeSelection | null,
    kvaPower: number | null,
    kwcPower: number | null
  ): EnergyProductionInfoModel | null {
    if (data !== null) {
      return { hasEnergyProduction: data, kVAPower: kvaPower, kwcPower }
    } else {
      return null
    }
  }
  //#endregion
}
</script>